import { useIntl } from 'react-intl';
import {
  BreadcrumbItem,
  Breadcrumbs,
} from '@rossum/components/breadcrumbs/Breadcrumbs';
import { extensionsPath } from '../routes';

export const ExtensionsBreadcrumbs = ({
  breadcrumbs,
}: {
  breadcrumbs: BreadcrumbItem[];
}) => {
  const intl = useIntl();

  const extensionsBreadcrumbs = [
    {
      to: extensionsPath(),
      label: intl.formatMessage({ id: 'components.appBar.extensions' }),
    },
    ...breadcrumbs,
  ] as const;

  return <Breadcrumbs breadcrumbs={extensionsBreadcrumbs} />;
};
